const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/blog",
    exact: true,
    component: "Blog",
  },
];

export default routes;
